// Author YuJiaBei
// Date 2020-08-07 15:55:23

import * as model from "@/model/em/lifecycle/EmLcScrReasonSreaModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmLcScrReasonSrea(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_LIFECYCLE_URL,
    })
    .buildStore()
